/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskProximityOneScan } from './ExecRiskProximityOneScan';
import {
    ExecRiskProximityOneScanFromJSON,
    ExecRiskProximityOneScanFromJSONTyped,
    ExecRiskProximityOneScanToJSON,
} from './ExecRiskProximityOneScan';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedProximityOneResponse
 */
export interface ExecRiskPaginatedProximityOneResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedProximityOneResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskProximityOneScan>}
     * @memberof ExecRiskPaginatedProximityOneResponse
     */
    results: Array<ExecRiskProximityOneScan>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedProximityOneResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedProximityOneResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedProximityOneResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedProximityOneResponse interface.
 */
export function instanceOfExecRiskPaginatedProximityOneResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedProximityOneResponseFromJSON(json: any): ExecRiskPaginatedProximityOneResponse {
    return ExecRiskPaginatedProximityOneResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedProximityOneResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedProximityOneResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskProximityOneScanFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedProximityOneResponseToJSON(value?: ExecRiskPaginatedProximityOneResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskProximityOneScanToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

